import { Tab } from '@mui/material'
import Tabs, { TabsProps } from '@mui/material/Tabs'

import Box, { BoxProps } from 'app/components/base/Box'
import { OptionModel } from 'app/hooks/useOptions'

export interface DesktopTabsProps {
  tabs: OptionModel[]
  value: string
  onTabChange: TabsProps['onChange']
  sx?: BoxProps['sx']
}

const DesktopTabs: RFC<DesktopTabsProps> = ({
  tabs,
  value,
  onTabChange,
  sx
}) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', ...sx }}>
      <Tabs
        value={value}
        onChange={onTabChange}
        aria-label="Category of articles"
        sx={{
          '& .MuiButtonBase-root': {
            textTransform: 'Capitalize'
          }
        }}
      >
        {tabs.map(({ label, value }) => (
          <Tab
            key={value}
            label={label}
            value={value}
            aria-label={`category ${label}`}
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default DesktopTabs
